import React from "react";
import {
  Button,
  Col,
  DatePicker,
  DatePickerProps,
  Row,
  Select,
  Space,
} from "antd";
import { Download, Copy } from "lucide-react";
import dayjs from "dayjs";
import { LocationType } from "../../modal/location-types";

interface WeekViewToolbarProps {
  location: LocationType[];
  handleLocationSearch: (key: React.Key) => void;
  handleLocationSearchClear: () => void;
  onWeekChange: (dateString: string) => void;
  onCurrentWeek: () => void;
  onExportSchedule: () => void;
  onCloneSchedule: () => void;
}

const WeekViewToolbar: React.FC<WeekViewToolbarProps> = ({
  location,
  handleLocationSearch,
  handleLocationSearchClear,
  onWeekChange,
  onCurrentWeek,
  onExportSchedule,
  onCloneSchedule,
}) => {
  const currDate = new Date();

  const handleonWeekChange: DatePickerProps["onChange"] = (date) => {
    // Have to set the Time of the day as well, otherwise it offsets the day by 1.
    //handleWeekChange(currDate.toDateString());
    if (date) {
      onWeekChange(date!.toISOString() as string);
    }
  };

  return (
    <Row gutter={16} align="middle">
      {/* First Column: Filters */}
      <Col xs={24} sm={24} md={8} lg={8} xl={8} style={{ padding: 20 }}>
        <Space size={6} wrap>
          <DatePicker
            defaultValue={dayjs(currDate)}
            onChange={handleonWeekChange}
            picker="week"
          />
          <Select
            showSearch
            allowClear
            onClear={handleLocationSearchClear}
            style={{ width: 200 }}
            placeholder="Filter by location"
            optionFilterProp="children"
            onSelect={handleLocationSearch}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={location.map((emp) => ({
              value: emp.key,
              label: emp.name,
            }))}
          />
        </Space>
      </Col>

      {/* Second Column: Actions */}
      <Col xs={24} sm={24} md={16} lg={16} xl={16} style={{ padding: 20 }}>
        <Space
          align="center"
          style={{
            width: "100%",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            display: "flex",
          }}
        >
          <Button onClick={onCurrentWeek}>Current Week</Button>
          <Button icon={<Copy size={12} />} onClick={onCloneSchedule}>
            Clone Schedule
          </Button>
          <Button
            type="primary"
            icon={<Download size={12} />}
            onClick={onExportSchedule}
          >
            Export Schedule
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

export default WeekViewToolbar;
